export default class AddedLeaguesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.leagues === undefined || content.leagues.add === undefined) {
            return;
        }

        const leagues = content.leagues.add;

        for (let i = 0; i < leagues.length; i++) {
            const league = leagues[i];

            const key = this._modelKeyRepository.addLeague(league.s, league.id);

            leagues[i] = Object.assign({
                name: league.n,
                priority: league.p
            }, key);
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/AddedLeaguesModifier.js